import { error } from 'console';
import axiosClient from './axiosClient';

export const getItinerary = (id?: any): Promise<any> => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/quotes/api/quote/${id}/itinerary`;
    return axiosClient.get(url);
};
